import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import copy from 'copy-to-clipboard';
import { TypedMemo } from '../../types';
import { openExternal } from '../../../../utils/openExternal';
import styles from './ToastLink.module.scss';

interface ToastLinkProps {
  url: string;
}

/**
 * The address a toast is about, with the two things worth doing to it.
 *
 * A re-published page gets a toast instead of the full sheet, and the address
 * is the only part of that sheet the artist may still want.
 */
const ToastLinkComponent: React.FC<ToastLinkProps> = ({ url }) => {
  const intl = useIntl();
  const [isCopied, setIsCopied] = useState(false);

  const onCopy = useCallback(() => {
    copy(url);
    setIsCopied(true);
  }, [url]);

  const onView = useCallback(() => {
    openExternal(url).catch(console.error);
  }, [url]);

  return (
    <div className={styles.link}>
      <span className={styles.url}>{url.replace(/^https?:\/\//, '')}</span>
      <span className={styles.buttons}>
        <button type="button" className={styles.button} onClick={onCopy}>
          {isCopied
            ? intl.formatMessage({ id: 'app.sml.published.copied', defaultMessage: 'Copied' })
            : intl.formatMessage({ id: 'app.buttons.copy_link', defaultMessage: 'COPY LINK' })}
        </button>
        <button type="button" className={styles.button} onClick={onView}>
          {intl.formatMessage({ id: 'app.buttons.open', defaultMessage: 'Open' })}
        </button>
      </span>
    </div>
  );
};

export const ToastLink = TypedMemo(ToastLinkComponent);
